"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class BadRequestParametersError extends client_library_1.ExtendableError {
    constructor() {
        super(`Bad request params`);
    }
}
exports.default = BadRequestParametersError;
//# sourceMappingURL=BadRequestParametersError.js.map